import axios from 'axios';

class Api {
  constructor() {
    this.baseUrl  = '';
    this.postType = '';
    this.postTerm = '';

    this._extractBaseUrl();
    this._extractPostType();
    this._extractPostTerm();
  }

  _extractBaseUrl() {
    const body   = document.getElementsByTagName('body')[0];
    this.baseUrl = this._trimSlashes(body.dataset['baseUrl'] || '');
  }

  _extractPostType() {
    const content = document.getElementById('layoutContent');
    this.postType = this._trimSlashes(content.dataset['postType'] || '');
  }

  _extractPostTerm() {
    const content = document.getElementById('layoutContent');
    this.postTerm = content.dataset['postTerm'] || '';
  }

  // TODO: convert to async / await
  get(options = {}, fn = () => {}) {
    const endpoint = this._getEndpoint();

    axios.get(`${this.baseUrl}/${endpoint}`, {
      params: {
        post_type: this.postType,
        herb_cat: this.postTerm,
        page: options.page || '',
        symbol: options.symbol || '',
      }
    }).then(response => {
      const posts = this._isHerbarium()
        ? this._extractHerbarium(response)
        : this._extractOther(response);

      fn({
        posts: posts,
        totalPages: response.data.max_num_pages
      });
    }).catch(e => console.error(e));
  }

  _getEndpoint() {
    return this._isHerbarium()
      ? 'wp-json/rest/herbariums'
      : 'wp-json/rest/data';
  }

  _isHerbarium() {
    return this.postType === 'herbarium' && !this.postTerm;
  }

  _trimSlashes(str) {
    return str.trim('').replace(/^\/+|\/+$/g, '');
  }

  _extractHerbarium(response) {
    return Object.values(response.data.posts).map(rawEntry => ({
      name: rawEntry.name,
      url: `${this.baseUrl}/${rawEntry.taxonomy}/${rawEntry.slug}`
    }));
  }

  _extractOther(response) {
    return Object.values(response.data.posts).map(rawEntry => ({
      name: rawEntry.post_title,
      url: rawEntry.guid
    }));
  }
}

export const api = new Api();
